import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { setUserSession, getToken } from "../Utils/Common";
import { getFirstPagePath, validateRoutesByRole } from "../Utils/Authorization";
import { useDispatch, useSelector } from "react-redux";
import { getCompany } from "../api/AccountsApi";
import {
    setUserRole,
    setUserEmail,
    setCompanyLevelComplaiceFlag,
} from "ReduxStore/Slices/userSlice";
import "bootstrap";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { ReactComponent as Icon } from "views/UserGuide/Icon.svg"

const Signup = (props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [showPassword, seShowPassword] = useState(false);
    const [typeChange, setTypeChange] = useState("password");
    const [disabled, setDisabled] = useState(true);
    const [captcha, setCapt] = useState(false);
    const [userPlan, setUserPlan] = useState('')
    const [publisher , setPublisher] = useState(false)
    const emailField = useRef("");
    const addressField = useRef("");
    const firstName = useRef("");
    const lastName = useRef("");
    const companyName = useRef("");
    const title = useRef("");
    const phone = useRef("");
    const webpageUrl = useRef("")
    const ref =useRef("");
    const setdisabledState = (c) => {
        let cap = c || captcha
        let val = false
        if (emailField.current.value && firstName.current.value && lastName.current.value
            && companyName.current.value && title.current.value && cap && phone.current.value && addressField.current.value) {
            val = true
        }
        if(publisher && !webpageUrl.current.value)
            val = false
        setDisabled(!val)
    }

    // handle button click of login form
    const handleSignUp = (e) => {
        e.preventDefault()
        let body = {
            email: emailField.current.value.trim(),
            companyName:companyName.current.value.trim(),
            firstName: firstName.current.value.trim(),
            lastName: lastName.current.value.trim(),
            title: title.current.value.trim(),
            contactTelephone: phone.current.value.trim(),
            address: addressField.current.value.trim(),
            recaptchaToken: captcha,
            plan: userPlan,
            isPublisher : publisher,
            websiteUrl : publisher? webpageUrl.current.value.trim() : null
        }
        if (captcha) {
            setLoading(true);
            axios
                .post(process.env.REACT_APP_API_BASE_URL + "company/onboard",
                    body
                )
                .then(async (response) => {
                    setSuccess(true);
                    setLoading(false);
                })

                .catch(function (error) {
                    if (ref && ref.current)
                        ref.current.reset()
                    setCapt(null)
                        
                    setError(error?.response?.data?.message || "Error on the server side, please try again later")
                    setLoading(false);
                });
        } else {

            toast.error("Please verify that you are not a robot")
        }

    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const plan = urlParams.get('plan');
        const isPublisher = urlParams.get('isPublisher');
        setUserPlan(plan)
        setPublisher(isPublisher=='true'|| isPublisher == true? true :false)

        var url_string = window.location.href;
        var url = new URL(url_string);
        var noOfDaysV = url.searchParams.get("noOfDays");


    }, [])

    function onChangeReCAPTCHA(val) {
        setCapt(val)
    }
    return (
        <body>
            {success && <div className="ug-cover">
                <div className="ug-welcome signup-popup fadeIn" style={publisher? {height:"fit-content"} :{}}>
                    <span className="my-5"><Icon /></span>
                    <div className="ug-title mb-5" style={{ fontSize: '16px' }}>

                        {publisher? <span style={{textAlign:"left"}}>Before you can sign in to Kapitalwise with your username and password, you must activate the account by opening this link that is sent to you in an email.

<p style={{ margin: 0, fontWeight: 500 ,fontSize:"14px", color:"rgba(17,23,29,.6)"}}>• Go to your email inbox.</p>
<p style={{ margin: 0, fontWeight: 500,fontSize:"14px", color:"rgba(17,23,29,.6)"}}> • Open the email with the subject line: Welcome to Kapitalwise. If you do not find the email in your inbox, please check your spam or junk mail folders.</p>
<p style={{ margin: 0, fontWeight: 500,fontSize:"14px", color:"rgba(17,23,29,.6)"}} >• Please follow the link and reset your password.</p> </span>

:"Data security and the privacy of our community are important to us. Someone from the Kapitalwise support team will review your request and get back to you with the next steps in 24hrs." }             </div>
                    <div className="ug-subtitle" style={{ fontSize: '12px' }}>
                        {publisher? "if you have any additional queries, feel free to reach out to us at support@kapitalwise.com":"Please check your inbox for an email from support@kapitalwise.com. If you have any additional queries, feel free to reach out to us."}
                    </div>
                </div>
            </div>}
            <div class="container">
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-8 mx-auto mt-3">
                        <div style={{ position: "absolute", top: "-10px", right: "-80px" }}>
                            <img
                                alt="Kapitalwise"
                                src={require("assets/img/login_top_back.svg")}
                            />
                        </div>
                        <div
                            class="card border border-1"
                            style={{
                                transform: 'scale(0.9)',
                                transformOrigin: '50% 10%',
                                borderColor: "#A6ABC9",
                                borderRadius: "20px",
                                zIndex: "1",
                                marginTop: "0px"
                            }}
                        >
                            <div class="card-body p-5" style={{ padding: "2rem 3rem" }}>
                                <div className="d-flex justify-content-center align-items-center p-2">
                                    <img
                                        alt="Kapitalwise"
                                        src={require("assets/img/logo.svg")}
                                        style={{ width: "3em", height: "3em" }}
                                    />{" "}
                                    <span className="nav_brand_text">Kapitalwise</span>
                                </div>
                                <div className="login_title d-flex justify-content-center align-items-center p-2">
                                    <text>Create your account</text>
                                </div>


                                <form onSubmit={handleSignUp}>
                                    <div
                                        class="form-floating mb-3"
                                        style={{ lineHeight: "35px" }}

                                    >
                                        <div className="signup-cont">
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">First Name</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={firstName}
                                                    required
                                                />
                                            </span>
                                            <span class="ml-2"></span>
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">Last Name</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}

                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={lastName}
                                                    required
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="form-floating mb-3"
                                        style={{ lineHeight: "35px" }}

                                    >
                                        <div className="signup-cont">
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">Title</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={title}
                                                />
                                            </span>
                                            <span class="ml-2"></span>
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">{"Company Name"}</text>
                                                <input
                                                    type={"text"}
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={companyName}
                                                />
                                            </span>
                                        </div>
                                    </div>

                                   {publisher&& <div
                                        class="form-floating mb-3"
                                        style={{ lineHeight: "35px" }}

                                    >
                                        <div className="signup-cont">

                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">{"Website Url"}</text>
                                                <input
                                                    type={"url"}
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={webpageUrl}
                                                />
                                            </span>
                                        </div>
                                    </div> 
                                    }

                                    <div
                                        class="form-floating mb-3"
                                        style={{ lineHeight: "35px" }}
                                    >
                                        <div className="signup-cont">
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">Email</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    type='email'
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={emailField}
                                                />
                                            </span>
                                            <span class="ml-2"></span>
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">Phone</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={phone}
                                                />
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        class="form-floating mb-3"
                                        style={{ lineHeight: "35px" }}
                                    >
                                        <div className="signup-cont">
                                            <span style={{ flex: 1 }}>
                                                <text className="text-label-1">Address</text>
                                                <input
                                                    onChange={(e) => { setdisabledState() }}
                                                    required
                                                    class="form-control m-0 h-45"
                                                    id="floatingInput"
                                                    ref={addressField}
                                                />
                                            </span>
                                            <span class="ml-2"></span>
                                            <span style={{ flex: 1 }}>
                                                <ReCAPTCHA
                                                    ref={ref}
                                                    sitekey="6LeY3eIfAAAAAGv9srvUz0LajS8ZolbNPSVFqrs1"
                                                    onChange={onChangeReCAPTCHA} />
                                            </span>
                                        </div>
                                    </div>



                                    <div className='mb-2 mt-3'
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            color: '#516f90',
                                            display: 'flex',

                                        }}
                                    >              

                                        <span>
                                            By clicking "Create Account", I accept the Kapitalwise Terms of Service and Privacy Notice.<br></br>
                                            <a style={{ fontWeight: 'bold', color: '#2c40ce' }} href={ publisher?"https://kapitalwise.com/PubTermsAndConditions.html": "https://www.kapitalwise.com/TermsAndConditions.html"} target="_blank">Terms of Service</a>&nbsp;&nbsp;
                                            <a style={{ fontWeight: 'bold', color: '#2c40ce' }} href="https://www.kapitalwise.com/PrivacyPolicy.html" target="_blank">Privacy Notice</a>
                                        </span>
                                    </div>

                                    {error && (
                                        <>
                                            <div id="er" style={{ color: "red" }}>
                                                <div dangerouslySetInnerHTML={{ __html: error }} ></div>
                                            </div>
                                            <br />
                                        </>
                                    )}

                                    <div class="login_btn">
                                        <button class="xl_btn primary w_100 mt-2" type="submit">
                                            {loading ? "Loading..." : "Create Account"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div style={{ position: "absolute", bottom: "0px", left: "-40px" }}>
                            <img
                                alt="Kapitalwise"
                                src={require("assets/img/login_bottom_back.svg")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </body>
    );
}

export default Signup;
